module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "d-table d-table__tasks"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "th-sorter",
    class: {
      'th-sorter--active': _vm.sortKey === 'name'
    },
    on: {
      "click": function($event) {
        return _vm.setSortKey('name')
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.getI18n(_vm.title)) + "\n      "), _c('span', {
    staticClass: "icon-menu-open"
  })]), _vm._v(" "), _c('th', {
    staticClass: "th-sorter",
    class: {
      'th-sorter--active': _vm.sortKey === 'calendar'
    },
    on: {
      "click": function($event) {
        return _vm.setSortKey('calendar')
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('vue2.task_overview.belongs_to')) + "\n      "), _c('span', {
    staticClass: "icon-menu-open"
  })]), _vm._v(" "), (!_vm.isOnlyShowScheduled) ? _c('th', {
    staticClass: "is-number th-sorter",
    class: {
      'th-sorter--active': _vm.sortKey === 'hours'
    },
    on: {
      "click": function($event) {
        return _vm.setSortKey('hours')
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('vue2.assign_users_hours.assigned')) + "\n      "), _c('span', {
    staticClass: "icon-menu-open"
  })]) : _vm._e(), _vm._v(" "), (_vm.isShowScheduled) ? _c('th', {
    staticClass: "th-sorter is-number",
    class: {
      'th-sorter--active': _vm.sortKey === 'actual'
    },
    on: {
      "click": function($event) {
        return _vm.setSortKey('actual')
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('vue2.assign_users_hours.scheduled')) + "\n      "), _c('span', {
    staticClass: "icon-menu-open"
  })]) : _vm._e(), _vm._v(" "), (_vm.isShowScheduled && !_vm.isOnlyShowScheduled) ? _c('th', {
    staticClass: "th-sorter is-number",
    class: {
      'th-sorter--active': _vm.sortKey === 'diff'
    },
    on: {
      "click": function($event) {
        return _vm.setSortKey('diff')
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('vue2.assign_users_hours.diff')) + "\n      "), _c('span', {
    staticClass: "icon-menu-open"
  })]) : _vm._e()])]), _vm._v(" "), _c('tbody', [(_vm.tasks.length < 1) ? _c('tr', [_c('td', {
    staticStyle: {
      "width": "90%"
    }
  }, [_c('div', {
    staticClass: "italic",
    staticStyle: {
      "padding": "4px"
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.task_overview.no_tasks_assigned')))])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), (_vm.isShowScheduled) ? _c('td') : _vm._e(), _vm._v(" "), (_vm.isShowScheduled) ? _c('td') : _vm._e()]) : _vm._e(), _vm._v(" "), _vm._l((_vm.sortedTasks), function(task) {
    return _c('tr', {
      key: task.id,
      attrs: {
        "data-task-id": task.id
      }
    }, [_c('td', [_c('div', {
      staticClass: "task-with-edit"
    }, [(task.can_schedule === 't') ? _c('div', {
      staticClass: "subjects_subject",
      style: ({
        'background': task.color
      })
    }, [_vm._v("\n          " + _vm._s(task.name) + "\n        ")]) : _c('div', {
      staticClass: "subjects_subject subjects_subject--not-subject"
    }, [_vm._v(_vm._s(task.name))])])]), _vm._v(" "), _c('td', {
      staticClass: "td-calendars"
    }, [_vm._v("\n      " + _vm._s(task.calendar) + "\n    ")]), _vm._v(" "), (!_vm.isOnlyShowScheduled) ? _c('td', {
      staticClass: "is-number"
    }, [_vm._v(_vm._s(_vm.getTasksHours(task)))]) : _vm._e(), _vm._v(" "), (_vm.isShowScheduled) ? _c('td', {
      staticClass: "is-number"
    }, [_vm._v(_vm._s(_vm.getTaskActual(task)))]) : _vm._e(), _vm._v(" "), (_vm.isShowScheduled && !_vm.isOnlyShowScheduled) ? _c('td', {
      staticClass: "is-number"
    }, [_vm._v(_vm._s(task.diff))]) : _vm._e()])
  })], 2), _vm._v(" "), _c('tfoot', [_c('tr', [_c('td'), _vm._v(" "), _c('td'), _vm._v(" "), (!_vm.isOnlyShowScheduled) ? _c('td', {
    staticClass: "is-number",
    class: {
      'th-sorter--active': _vm.sortKey === 'hours'
    }
  }, [_vm._v(_vm._s(_vm.sumOfHours))]) : _vm._e(), _vm._v(" "), (_vm.isShowScheduled) ? _c('td', {
    staticClass: "is-number",
    class: {
      'th-sorter--active': _vm.sortKey === 'actual'
    }
  }, [_vm._v(_vm._s(_vm.sumOfActual) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.isShowScheduled && !_vm.isOnlyShowScheduled) ? _c('td', {
    staticClass: "total-hours is-number",
    class: {
      'th-sorter--active': _vm.sortKey === 'diff'
    }
  }, [_vm._v("\n      " + _vm._s(_vm.sumOfDiff) + "\n    ")]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2aec7768!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/User/UserTasksTable.vue
// module id = 1523
// module chunks = 1